module.exports = __webpack_public_path__ + "img/cat-404.f8ebf927.png";